import axios from 'axios'
import { isStageUrl } from './helper'

const hostname = window.location.hostname
const isLocalUrl = ['localhost', '127.0.0.1', '::1'].includes(hostname)
const baseENV = isStageUrl() ? 'DEV' : 'LIVE'
export const baseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (baseENV === 'DEV'
    ? 'https://portal-api-dev.sopra.services'
    : 'https://portal-api.sopra.services')
// export const baseUrl = 'https://localhost:44384'

let last = 0

export const loadData = async ({
  url,
  params = [],
  userToken,
  throwOnError = false,
}) => {
  let paramsUrl = ''
  const current = ++last

  if (typeof params === 'object') {
    try {
      if (params.length > 0) {
        paramsUrl = '?'
        params.map((item, index) => {
          const value =
            item.title !== 'searchKey'
              ? encodeURIComponent(
                typeof item.value === 'string'
                  ? item.value.trim()
                  : item.value,
              )
              : item.value
          paramsUrl +=
            item.title + '=' + value + (index === params.length - 1 ? '' : '&')
        })
      }
    } catch (err) {
      console.log(err)
    }
    console.log(`endpoint: ${baseUrl}/${url}${paramsUrl}`)
  } else {
    console.log(`endpoint: ${baseUrl}/${url}/${params}`)
  }

  try {
    let res = ''
    if (userToken) {
      if (typeof params !== 'object') {
        res = await axios.get(`${baseUrl}/${url}/${params}`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
      } else {
        res = await axios.get(`${baseUrl}/${url}${paramsUrl}`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
      }
    } else {
      if (typeof params !== 'object') {
        res = await axios.get(`${baseUrl}/${url}/${params}`)
      } else {
        res = await axios.get(`${baseUrl}/${url}${paramsUrl}`)
      }
    }

    return Promise.resolve(res.data)
  } catch (err) {
    console.error(err + ': ' + url)

    if (throwOnError) {
      const error = new Error(
        err?.response?.data?.message || err?.message || 'Request failed',
      )
      error.response = err?.response
      throw error
    }
  }
}

export const addData = async ({
  url,
  params = [],
  reqBody = null,
  userToken = null,
}) => {
  let paramsUrl = ''

  try {
    if (Array.isArray(params) && params.length > 0) {
      paramsUrl = '?'
      params.map((item, index) => {
        const value = encodeURIComponent(
          typeof item.value === 'string' ? item.value.trim() : item.value,
        )
        paramsUrl +=
          item.title + '=' + value + (index === params.length - 1 ? '' : '&')
      })
    }

    if (Array.isArray(params))
      console.log(`endpoint: ${baseUrl}/${url}${paramsUrl}`)

    let res

    if (Array.isArray(params) && reqBody === null) {
      // Params
      if (userToken) {
        res = await axios.post(`${baseUrl}/${url}${paramsUrl}`, null, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
      } else {
        res = await axios.post(`${baseUrl}/${url}${paramsUrl}`)
      }
    } else {
      // Body
      if (paramsUrl != '') {
        if (userToken) {
          res = await axios.post(`${baseUrl}/${url}${paramsUrl}`, reqBody, {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          })
        } else {
          res = await axios.post(`${baseUrl}/${url}${paramsUrl}`, reqBody)
        }
      } else {
        if (userToken) {
          res = await axios.post(
            `${baseUrl}/${url}`,
            reqBody ? reqBody : params,
            {
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
            },
          )
        } else {
          res = await axios.post(
            `${baseUrl}/${url}`,
            reqBody ? reqBody : params,
          )
        }
      }
    }
    return res.data
  } catch (err) {
    return err.response.data?.message
  }
}

export const updateData = async ({ url, params = [], reqBody = null, userToken = null }) => {
  let paramsUrl = ''

  try {
    if (Array.isArray(params) && params.length > 0) {
      paramsUrl = '?'
      params.map((item, index) => {
        const value = encodeURIComponent(
          typeof item.value === 'string' ? item.value.trim() : item.value,
        )
        paramsUrl +=
          item.title + '=' + value + (index === params.length - 1 ? '' : '&')
      })
    }

    if (Array.isArray(params))
      console.log(`endpoint: ${baseUrl}/${url}${paramsUrl}`)

    let res

    if (reqBody) {

      if (Array.isArray(params) && reqBody === null) {
        // Params
        res = await axios.put(`${baseUrl}/${url}${paramsUrl}`)
      } else {
        // Body
        if (paramsUrl != '') {
          res = await axios.put(`${baseUrl}/${url}${paramsUrl}`, reqBody)
        } else {
          if (userToken) {
            res = await axios.put(
              `${baseUrl}/${url}`,
              reqBody ? reqBody : params,
              {
                headers: {
                  Authorization: `Bearer ${userToken}`,
                },
              },
            )
          } else {
            res = await axios.put(
              `${baseUrl}/${url}`,
              reqBody ? reqBody : params,
            )
          }
        }
      }
    } else {
      if (Array.isArray(params)) {
        // Params
        if (userToken) {
          res = await axios.put(`${baseUrl}/${url}${paramsUrl}`, null, {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          })
        } else {
          res = await axios.put(`${baseUrl}/${url}${paramsUrl}`)
        }
      } else {
        // Body
        if (userToken) {
          res = await axios.put(`${baseUrl}/${url}`, params, {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          })
        } else {
          res = await axios.put(`${baseUrl}/${url}`, params)
        }
      }
    }

    return res.data
  } catch (err) {
    throw err.response.data?.message
  }
}

export const deleteData = async ({ url, id, userToken }) => {
  try {
    let res

    res = await axios.delete(`${baseUrl}/${url}/${id}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${userToken}`,
      },
    })
    return res.data
  } catch (err) {
    throw err.response.data?.message
  }
}
